<template>
  <!-- 评价成功 -->
  <div class="content">
    <div class="header">
      <van-nav-bar :fixed="true" :placeholder="true" title="评价成功" />
      <div class="headerTop" @click="$router.push('/personalCenter')">
        <img src="../../assets/img/jiantou.png" alt="" />
      </div>
    </div>
    <!-- 查看评价 -->
    <div class="examine">
      <p>
        <img src="../../assets/img/组 9701@2x.png" alt="" />
        评价成功，非常感谢！
      </p>
      <h5 v-if="this.file!==0">图片提交成功，我们需要1至3个工作日审核图片，请留意审核结果</h5>
      <button class="btn" @click="$router.push('/evaluationCenter?type=2')">
        查看评价
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      file:sessionStorage.getItem('FILE'),
    }
  },
  created(){
  },
  methods: {
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  position: relative;
  .headerTop {
    position: absolute;
    top: 0.373333rem;
    left: 0.32rem;
    z-index: 99;
    img {
      width: 0.426667rem;
      height: 0.426667rem;
    }
  }
  .examine {
    width: 100%;
    margin: 0 auto;
    p {
      padding: 2rem 2rem 0.5rem 2rem;
      font-size: 0.48rem;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0.533333rem;
      color: #000000;
      opacity: 1;
      text-align: center;
      img {
        width: 0.533333rem;
        height: 0.533333rem;
        vertical-align: middle;
      }
    }
    h5 {
      padding: 0.5rem 0.6rem;
    }
    .btn {
      margin: 0 auto;
      text-align: center;
      display: block;
      width: 8rem;
      height: 1.333333rem;
      border: 0px;
      background: #f74b2e;
      color: white;
      opacity: 1;
      border-radius: 1.386667rem;
    }
  }
}
</style>
